/**
 * 专利卫士 规费指引
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>规费指引</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.country" style="width:140px" placeholder="输入国家" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.type" style="width:140px" placeholder="输入类型" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="80">
      </el-table-column>
      <el-table-column prop="log_id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="country" align="center" label="国家" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" align="center" label="类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sign" align="center" label="签名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delGuide(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog('guideData')">
      <el-form label-width="120px" :model="guideData" ref="guideData">
        <el-row>
          <el-col :span="8">
            <el-form-item label="国家">
              <el-input size="small" v-model="guideData.country" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型">
              <el-input size="small" v-model="guideData.type" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签名">
              <el-input size="small" v-model="guideData.sign" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
        <el-row class="demo-autocomplete">
              <el-col :span="5">
                <div class="sub-title" style="color: #909399">类目</div>
              </el-col>
              <el-col :span="3" style="margin-left: 15px">
                <div class="sub-title" style="color: #909399">金额(无费减)</div>
              </el-col>
              <el-col :span="3" style="margin-left: 15px">
              <div class="sub-title" style="color: #909399">费减(70%)</div>
              </el-col>
              <el-col :span="3" style="margin-left: 15px">
                <div class="sub-title" style="color: #909399">费减(85%)</div>
              </el-col>
          </el-row>
      </el-form-item>

       <el-form-item
        v-for="(item, index) in guideData.item"
        :label="'类目' + index"
        :key="item.key"
      >
      <el-row class="demo-autocomplete">
            <el-col :span="5">
              <el-input :prop="item.category" v-model="item.category" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:申请费" clearable></el-input>
            </el-col>
            <el-col :span="3" style="margin-left: 15px">
            <el-input :prop="item.value1" v-model="item.value1" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:900" clearable></el-input>
            </el-col>
            <el-col :span="3" style="margin-left: 15px">
              <el-input :prop="item.value2" v-model="item.value2" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:270" clearable></el-input>
            </el-col>
            <el-col :span="3" style="margin-left: 15px">
              <el-input :prop="item.value3" v-model="item.value3" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:135" clearable></el-input>
            </el-col>
            <el-button @click.prevent="removeDomain(item)" style="margin-left: 15px">删除</el-button>
            <el-button @click.prevent="addOnNodeDomain(item)" title="当前节点上方添加录入框">添加(上)</el-button>
            <el-button @click.prevent="addNextNodeDomain(item)" title="当前节点下方添加录入框">添加(下)</el-button>
      </el-row>
        
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveGuide()">提交</el-button>
      </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getGuidePageList, editGuide, delGuide, wechatUrl } from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '',
      multipleSelection: [],
      infoForm: {
        id: '',
        country: '',
        type: '',
        item: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        country: '',
        type: '',
      },
      guideData: {
        id: '',
        country: '',
        type: '',
        sign: '',
        item:[{
          category: '',
          value1: '',
          value2: '',
          value3: ''
        }]
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getGuidePageList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res);
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 显示编辑页面
    handleEdit: function(index,row){
      if(row){
        this.guideData.id = row.id,
        this.guideData.country = row.country,
        this.guideData.type = row.type,
        this.guideData.sign = row.sign,
        this.guideData.item = row.item,
        this.title = '编辑规费指引'
      }else{
        this.title = '添加规费指引'
        this.guideData.id = '',
        this.guideData.country = '',
        this.guideData.type = '',
        this.guideData.sign = '',
        this.guideData.item = [{
          category: '',
          value1: '',
          value2: '',
          value3: ''
        }]
      }
      this.editFormVisible = true
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    removeDomain(item) {
      var index = this.guideData.item.indexOf(item)
      if (index !== -1) {
        this.guideData.item.splice(index, 1)
      }
    },
    // 当前节点添加输入行
    addOnNodeDomain(item) {
      var index = this.guideData.item.indexOf(item)
      this.guideData.item.splice(index, 0,{key: Date.now()})
    },
    addNextNodeDomain(item) {
      var index = this.guideData.item.indexOf(item)
      this.guideData.item.splice(index+1, 0,{key: Date.now()})
      console.log(this.guideData)
    },
    // 保存规费指引
    saveGuide(){
     let id = this.guideData.id
     let country = this.guideData.country
     let type = this.guideData.type
     let item = this.guideData.item
     let sign = this.guideData.sign
     if(!country || !type || !sign){
        this.$message({
          type: 'error',
          message: '所有输入框都是必填项!'
        })
        return false;
     }
     editGuide({id:id,country:country,type:type,sign:sign,item:JSON.stringify(item)})
     .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getdata()
          this.editFormVisible = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
          return false;
        }
     })

    },
    // 删除规费指引
    delGuide(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delGuide({id: row.id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getdata()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/Guide.vue